import {InvoiceState} from "./InvoiceState";
import {Action, handleActions} from "redux-actions";
import {
	INVOICE_EVENTS_FETCHED,
	INVOICE_FETCHED,
	INVOICE_PAYMENTS_FETCHED,
	INVOICE_UPDATED
} from "../../action/invoice/actionType";

const initState: InvoiceState = {
	invoicesMap: {}, events: {}, payments: {}
};

const reducer = handleActions({
	[INVOICE_FETCHED]: (state: InvoiceState, action: Action<any>): InvoiceState => {
		return {
			...state, invoicesMap: {
				...state.invoicesMap,
				[action.payload.jobId]: action.payload.invoice
			}
		}
	},
	[INVOICE_UPDATED]: (state: InvoiceState, action: Action<INVOICE_UPDATED>): InvoiceState => {
		return {
			...state, invoicesMap: {
				...state.invoicesMap,
				[action.payload.jobId]: action.payload.invoice
			}
		}
	},
	[INVOICE_EVENTS_FETCHED]: (state: InvoiceState, action: Action<INVOICE_EVENTS_FETCHED>): InvoiceState => {
		const invoiceEvents = {...state.events, [action.payload.invoiceId]: action.payload.events};
		return {...state, events: invoiceEvents};
	},
	[INVOICE_PAYMENTS_FETCHED]: (state: InvoiceState, action: Action<INVOICE_PAYMENTS_FETCHED>): InvoiceState => {
		const invoicePayments = {...state.payments, [action.payload.invoiceId]: action.payload.payments};
		return {...state, payments: invoicePayments};
	},
}, initState);

export default reducer;
